import { useGetJobsStatusQuery } from 'api/reports-service/reports-service';

type Props = {
  children: React.ReactNode;
};

const JobsStatusGate = ({ children }: Props) => {
  const { isLoading } = useGetJobsStatusQuery();
  if (isLoading) return null;
  return <>{children}</>;
};

export default JobsStatusGate;
